import api from './api';

/**
 * Fetch a paginated list of notifications for the current user.
 * @param {Object} params - Query parameters.
 * @param {number} params.page - Page number.
 * @param {boolean} params.unread - Filter by unread status.
 */
export const getNotifications = async ({ page = 1, unread = false } = {}) => {
    const params = { page };
    if (unread) {
        params.unread = 'true';
    }
    const response = await api.get('/api/v1/notifications', { params });
    return response.data; // Expected { items: [...], pagy: {...} }
};

/**
 * Mark a single notification as read.
 * @param {string|number} id - Notification ID.
 */
export const markNotificationAsRead = async (id) => {
    const response = await api.patch(`/api/v1/notifications/${id}/read`);
    return response.data; // Expected { item: {...} }
};

/**
 * Mark all notifications for the current user as read.
 */
export const markAllNotificationsAsRead = async () => {
    const response = await api.post('/api/v1/notifications/mark_all_as_read');
    return response.data; // Expected { success: true }
};

/**
 * Get the current count of unread notifications.
 */
export const getUnreadNotificationsCount = async () => {
    const response = await api.get('/api/v1/notifications/unread_count');
    return response.data; // Expected { count: X }
};
